import { fonts } from "../../assets/fonts/font";
import colorConfigs from "../../configs/colorConfigs";

const voucherPageStyles = {
  container: {
    p: 2,
  },
  title: {
    mb: 2,
  },
  card: {
    backgroundColor: colorConfigs.quaternary,
    borderRadius: '15px',
    boxShadow: 1,
    display: 'flex',
    alignItems: 'center',
    overflow: 'visible',
    borderStyle:'solid',
    borderWidth: 2,
    borderColor: colorConfigs.tertiary,
    paddingY: 0.5,
    height: '100%',
  },

  cardContent: {
    display: 'flex',
    width: '100%',
    height: '100%',
    gap: 3,
    flex: 1,
    py: 1,
    px: 1.5,
    alignItems: 'center',
  },
  logoBox: {
    display: 'flex',
    alignItems: 'center',
    maxWidth:'30%',
  },

  couponName: {
    color: colorConfigs.tertiary,
    fontSize: '14px',
  },
  couponDetails: {
    color: colorConfigs.tertiary,
    fontWeight: 'bold',
  },
  discountText: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: colorConfigs.tertiary,
  },
  minimumSpendingText: {
    fontSize: '12px',
    color: colorConfigs.tertiary,
    fontFamily: fonts.medium,
    
  },
  unavailableText: {
    display: 'block',
    mt: 0.5,
    fontSize: '10px',
    fontWeight: 700,
    color: colorConfigs.mutedText,
    letterSpacing: '0.04em',
    lineHeight: 1.3,
  },
  timeRuleText: {
    display: 'block',
    mt: 0.5,
    fontSize: '10px',
    fontWeight: 600,
    color: colorConfigs.voucherTimeText,
    lineHeight: 1.3,
  },
};

export default voucherPageStyles;
